import { filesize } from 'filesize'

export type FileSizeProps = {
  size: number
}
export const FileSize = ({ size }: FileSizeProps) => {
  return filesize(size)
}
